import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { SignUpPage } from "src/pages/SignUpPage";

const routeSearchSchema = z.object({
  code: z.string().optional(),
});

export const Route = createFileRoute("/_public/sign-up")({
  component: RouteComponent,
  ssr: true,
  validateSearch: routeSearchSchema,
});

function RouteComponent() {
  return <SignUpPage />;
}
